// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"4013d42c","262":"6e061bd8","415":"bf782c03","881":"ae7b0326"}[chunkId] + ".chunk.js";
};